import { Injectable } from '@angular/core';
import { Config } from '../model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentLoaderService {
  private appConfig: Config = {
    naervarmePortalUrl: '',
  };

  constructor(private http: HttpClient) {
    this.appConfig = new Config();
  }

  get config(): Config {
    return this.appConfig;
  }

  load(): Promise<any> {
    const promise = this.http
      .get('assets/json/runtime.json?' + Date.now())
      .toPromise()
      .then((settings: Config) => {
        this.appConfig = settings;
        return this.appConfig;
      })
      .catch((error) => {
        console.log('Error loading runtime.json - using environment file instead');
        this.appConfig = environment;
        return this.appConfig;
      });

    return promise;
  }

  isFeatureEnabled(feature: string): boolean {
    return this.config && this.config.hasOwnProperty(feature) ? JSON.parse(this.config[feature]) : false;
  }
}
